import { gql } from "@apollo/client";
import { ButtonBase } from "@mui/material";
import { COLOR_BLACK_LIGHTER, COLOR_GREY_BORDER } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import usePseudoStyle from "helpers/usePseudoStyle";
import DropdownItem, { DROPDOWN_FONT_SIZE } from "molecules/DropdownItem";
import GamePlayerAvatar, { GamePlayerAvatarFragment } from "molecules/GamePlayerAvatar";
import React from "react";

export const GamePlayerSelectorFragment = gql`
  fragment GamePlayerSelectorFragment on Game {
    id
    home {
      id
      name
    }
    away {
      id
      name
    }
    gamePlayers {
      id
      isHomeTeamPlayer
      ...GamePlayerAvatarFragment
      person {
        id
        fullNameWithAnonymisation
      }
      team {
        id
      }
    }
  }
  ${GamePlayerAvatarFragment}
`;

export default function GamePlayerSelector({ gamePlayerIdSet, game, gamePlayerId, teamId = null, onTeamSelect }) {
  const teams = game && [game.home, game.away].filter((team) => team && (!teamId || team.id === teamId));

  return (
    <>
      <div style={{ display: "flex" }}>
        {teams?.map((team) => (
          <div
            key={team.id}
            style={{
              display: "flex",
              flexFlow: "column nowrap",
              alignItems: "stretch",
              minWidth: 200,
              maxWidth: 220,
            }}
          >
            <TeamHeader team={team} onClick={onTeamSelect && (() => onTeamSelect(team.id))} />
            {game?.gamePlayers
              .filter((gp) => gp.team.id === team.id)
              .map((gamePlayer) => (
                <GamePlayerSelectorItem
                  key={gamePlayer.id}
                  selected={gamePlayer.id === gamePlayerId}
                  onClick={() => {
                    gamePlayerIdSet(gamePlayer.id);
                  }}
                  gamePlayer={gamePlayer}
                />
              ))}
          </div>
        ))}
      </div>
    </>
  );
}

// Clicking a team name selects the whole team, ie "All players"
function TeamHeader({ team, onClick }) {
  const { className } = usePseudoStyle(onClick ? { ":hover": "background-color: #f5f5f5 !important;" } : {});

  return (
    <ButtonBase
      className={className}
      onClick={onClick}
      disabled={!onClick}
      style={{
        display: "block",
        textAlign: "left",
        padding: "10px 12px",
        borderBottom: `1px solid ${COLOR_GREY_BORDER}`,
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontSize: DROPDOWN_FONT_SIZE,
        fontWeight: 500,
        letterSpacing: "0.01em",
        color: COLOR_BLACK_LIGHTER,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {team.name}
    </ButtonBase>
  );
}

export function GamePlayerSelectorItem({ gamePlayer, selected = false, onClick }) {
  return (
    <DropdownItem selected={selected} onClick={onClick}>
      <GamePlayerAvatar gamePlayer={gamePlayer} inverse={gamePlayer.isHomeTeamPlayer} style={{ fontSize: "1em" }} />
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: 160, // Ensure this element doesn't squeeze the player number avatar
        }}
      >
        {gamePlayer.person.fullNameWithAnonymisation}
      </div>
    </DropdownItem>
  );
}
